import { Flex } from "@/atoms"
import { ImageIcon, VmIcons } from "@/icons"
import {
  IMAGE_DRAWER_ID,
  VIRTUAL_MACHINE_DRAWER_ID
} from "@/organisms/Drawers/const"

import styles from "./MoreTableCellDrawer.module.scss"

import type { MoreTableCellProps } from "@/molecules/MoreTableCell"

export const RelatedResources = (item: MoreTableCellProps["items"][number]) => {
  const { name, subjectType, drawerId } = item
  const isImage = drawerId === IMAGE_DRAWER_ID
  const isVm = drawerId === VIRTUAL_MACHINE_DRAWER_ID

  if (isImage || isVm)
    return (
      <Flex align="center" gap={4}>
        {isVm && <VmIcons className={styles.iconVm} type={subjectType} />}
        {isImage && <ImageIcon hideTooltip imageSource="kodem" />}
        {name}
      </Flex>
    )

  return name
}
